<template>
  <div class="home-card online">
    <div class="card-title">
      <span class="method">申诉方式一</span>
      <span class="arrow"></span>
      <span class="text">在线投诉</span>
    </div>
    <div class="card-tips">
      进入在线申诉平台，按以下步骤在线提交信息，完成投诉：
    </div>
    <ul class="card-list">
      <li>
        <span class="icon first"></span>
        <div class="item">
          <h1>填写个人信息</h1>
          <ul class="item-list">
            <li>填写个人信息，包括姓名、电话、身份证信息等</li>
            <li>
              真实身份信息由国家权威机构进行认证，搜狐不保留相关信息。请放心填写
            </li>
          </ul>
        </div>
      </li>
      <li>
        <span class="icon second"></span>
        <div class="item">
          <h1>填写投诉详情和请求</h1>
          <ul class="item-list">
            <li>在“投诉内容”、“投诉原因”、“投诉请求”中填写需要申诉详情</li>
            <li>注意，要投诉的网页地址必须是搜狐的网址</li>
            <li>
              "涉未成年”类投诉请单独勾选涉未成年类别，将有专人联系处理，不涉及未成年投诉选此类型不予处理
            </li>
          </ul>
        </div>
      </li>
      <li>
        <span class="icon third"></span>
        <div class="item">
          <h1>相关资料提交</h1>
          <ul class="item-list">
            <li>
              如有其他辅助性的说明文件，请将扫描件发送邮件到客服邮箱kf@vip.sohu.com，
              邮件主题请注明：XXX投诉补充材料
            </li>
            <li>
              原则上申请人必须是相关权益人，若委托他人代为申请，请提供授权委托书及其申
              请人（委托人）和受托人的身份证复印件或公司执照复印件
            </li>
          </ul>
        </div>
      </li>
      <li>
        <span class="icon fourth"></span>
        <div class="item">
          <h1>投诉处理情况查询</h1>
          <ul class="item-list last">
            <li>在线提交申诉后，工作人员尽快核实处理</li>
            <li>您可致电客服中心 010-58511234 查询处理进度</li>
            <li>
              <a
                class="blue"
                target="_blank"
                href="https://mp.sohu.com/mpfe/v3/main/show/help?tab=aboutTort"
                >搜狐号投诉流程</a
              >
              <a
                class="blue"
                target="_blank"
                href="http://feedback.vrs.sohu.com/index.jsp?50"
                >搜狐视频投诉流程</a
              >
            </li>
          </ul>
        </div>
      </li>
    </ul>
    <div class="card-btns">
      <div class="btn online" @click="onlineComplaint">
        我要在线投诉
      </div>
      <div class="btn process" @click="checkComplaint">
        查看投诉进度
      </div>
    </div>
    <hy-popup :show="showPop" @hidePop="hidepop" />
  </div>
</template>

<script>
import HyPopup from "../../../components/HyPopup";

export default {
  props: {},
  data() {
    return {
      showPop: false
    };
  },
  components: {
    HyPopup
  },
  computed: {
    isLogin() {
      return this.$store.state.ppinf;
    }
  },
  methods: {
    hidepop() {
      this.showPop = false;
    },
    onlineComplaint() {
      if (!this.isLogin) {
        this.showPop = true;
      } else {
        let routeData = this.$router.resolve({
          name: "form"
        });
        window.open(routeData.href, "_blank");
      }
    },
    checkComplaint() {
      if (!this.isLogin) {
        this.showPop = true;
      } else {
        let routeData = this.$router.resolve({
          name: "record"
        });
        window.open(routeData.href, "_blank");
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/styles/index.scss";
</style>
